/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
export enum PreferredContactMethod {
  EMAIL = 0,
  PHONE = 1
}
/**
 * Message implementation for ten.grpc.booking_service.dto.AmountWithCurrency
 */
export class AmountWithCurrency implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.AmountWithCurrency';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AmountWithCurrency();
    AmountWithCurrency.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AmountWithCurrency) {
    _instance.amount = _instance.amount || '';
    _instance.currencyCode = _instance.currencyCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AmountWithCurrency,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.amount = _reader.readString();
          break;
        case 2:
          _instance.currencyCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AmountWithCurrency.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AmountWithCurrency,
    _writer: BinaryWriter
  ) {
    if (_instance.amount) {
      _writer.writeString(1, _instance.amount);
    }
    if (_instance.currencyCode) {
      _writer.writeString(2, _instance.currencyCode);
    }
  }

  private _amount: string;
  private _currencyCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AmountWithCurrency to deeply clone from
   */
  constructor(_value?: RecursivePartial<AmountWithCurrency.AsObject>) {
    _value = _value || {};
    this.amount = _value.amount;
    this.currencyCode = _value.currencyCode;
    AmountWithCurrency.refineValues(this);
  }
  get amount(): string {
    return this._amount;
  }
  set amount(value: string) {
    this._amount = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AmountWithCurrency.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AmountWithCurrency.AsObject {
    return {
      amount: this.amount,
      currencyCode: this.currencyCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AmountWithCurrency.AsProtobufJSON {
    return {
      amount: this.amount,
      currencyCode: this.currencyCode
    };
  }
}
export module AmountWithCurrency {
  /**
   * Standard JavaScript object representation for AmountWithCurrency
   */
  export interface AsObject {
    amount: string;
    currencyCode: string;
  }

  /**
   * Protobuf JSON representation for AmountWithCurrency
   */
  export interface AsProtobufJSON {
    amount: string;
    currencyCode: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.Phone
 */
export class Phone implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.Phone';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Phone();
    Phone.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Phone) {
    _instance.prefix = _instance.prefix || '';
    _instance.number = _instance.number || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Phone, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.prefix = _reader.readString();
          break;
        case 2:
          _instance.number = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Phone.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Phone, _writer: BinaryWriter) {
    if (_instance.prefix) {
      _writer.writeString(1, _instance.prefix);
    }
    if (_instance.number) {
      _writer.writeString(2, _instance.number);
    }
  }

  private _prefix: string;
  private _number: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Phone to deeply clone from
   */
  constructor(_value?: RecursivePartial<Phone.AsObject>) {
    _value = _value || {};
    this.prefix = _value.prefix;
    this.number = _value.number;
    Phone.refineValues(this);
  }
  get prefix(): string {
    return this._prefix;
  }
  set prefix(value: string) {
    this._prefix = value;
  }
  get number(): string {
    return this._number;
  }
  set number(value: string) {
    this._number = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Phone.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Phone.AsObject {
    return {
      prefix: this.prefix,
      number: this.number
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Phone.AsProtobufJSON {
    return {
      prefix: this.prefix,
      number: this.number
    };
  }
}
export module Phone {
  /**
   * Standard JavaScript object representation for Phone
   */
  export interface AsObject {
    prefix: string;
    number: string;
  }

  /**
   * Protobuf JSON representation for Phone
   */
  export interface AsProtobufJSON {
    prefix: string;
    number: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.Address
 */
export class Address implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.Address';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Address();
    Address.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Address) {
    _instance.houseNumber = _instance.houseNumber || '';
    _instance.addressLine1 = _instance.addressLine1 || '';
    _instance.addressLine2 = _instance.addressLine2 || '';
    _instance.postCode = _instance.postCode || '';
    _instance.city = _instance.city || '';
    _instance.countryCode = _instance.countryCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Address,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.houseNumber = _reader.readString();
          break;
        case 2:
          _instance.addressLine1 = _reader.readString();
          break;
        case 3:
          _instance.addressLine2 = _reader.readString();
          break;
        case 4:
          _instance.postCode = _reader.readString();
          break;
        case 5:
          _instance.city = _reader.readString();
          break;
        case 6:
          _instance.countryCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Address.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Address, _writer: BinaryWriter) {
    if (_instance.houseNumber) {
      _writer.writeString(1, _instance.houseNumber);
    }
    if (_instance.addressLine1) {
      _writer.writeString(2, _instance.addressLine1);
    }
    if (_instance.addressLine2) {
      _writer.writeString(3, _instance.addressLine2);
    }
    if (_instance.postCode) {
      _writer.writeString(4, _instance.postCode);
    }
    if (_instance.city) {
      _writer.writeString(5, _instance.city);
    }
    if (_instance.countryCode) {
      _writer.writeString(6, _instance.countryCode);
    }
  }

  private _houseNumber: string;
  private _addressLine1: string;
  private _addressLine2: string;
  private _postCode: string;
  private _city: string;
  private _countryCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Address to deeply clone from
   */
  constructor(_value?: RecursivePartial<Address.AsObject>) {
    _value = _value || {};
    this.houseNumber = _value.houseNumber;
    this.addressLine1 = _value.addressLine1;
    this.addressLine2 = _value.addressLine2;
    this.postCode = _value.postCode;
    this.city = _value.city;
    this.countryCode = _value.countryCode;
    Address.refineValues(this);
  }
  get houseNumber(): string {
    return this._houseNumber;
  }
  set houseNumber(value: string) {
    this._houseNumber = value;
  }
  get addressLine1(): string {
    return this._addressLine1;
  }
  set addressLine1(value: string) {
    this._addressLine1 = value;
  }
  get addressLine2(): string {
    return this._addressLine2;
  }
  set addressLine2(value: string) {
    this._addressLine2 = value;
  }
  get postCode(): string {
    return this._postCode;
  }
  set postCode(value: string) {
    this._postCode = value;
  }
  get city(): string {
    return this._city;
  }
  set city(value: string) {
    this._city = value;
  }
  get countryCode(): string {
    return this._countryCode;
  }
  set countryCode(value: string) {
    this._countryCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Address.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Address.AsObject {
    return {
      houseNumber: this.houseNumber,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      postCode: this.postCode,
      city: this.city,
      countryCode: this.countryCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Address.AsProtobufJSON {
    return {
      houseNumber: this.houseNumber,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      postCode: this.postCode,
      city: this.city,
      countryCode: this.countryCode
    };
  }
}
export module Address {
  /**
   * Standard JavaScript object representation for Address
   */
  export interface AsObject {
    houseNumber: string;
    addressLine1: string;
    addressLine2: string;
    postCode: string;
    city: string;
    countryCode: string;
  }

  /**
   * Protobuf JSON representation for Address
   */
  export interface AsProtobufJSON {
    houseNumber: string;
    addressLine1: string;
    addressLine2: string;
    postCode: string;
    city: string;
    countryCode: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.GuestDetail
 */
export class GuestDetail implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.GuestDetail';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GuestDetail();
    GuestDetail.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GuestDetail) {
    _instance.type = _instance.type || '';
    _instance.title = _instance.title || '';
    _instance.firstName = _instance.firstName || '';
    _instance.lastName = _instance.lastName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GuestDetail,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.type = _reader.readString();
          break;
        case 2:
          _instance.title = _reader.readString();
          break;
        case 3:
          _instance.firstName = _reader.readString();
          break;
        case 4:
          _instance.lastName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GuestDetail.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GuestDetail,
    _writer: BinaryWriter
  ) {
    if (_instance.type) {
      _writer.writeString(1, _instance.type);
    }
    if (_instance.title) {
      _writer.writeString(2, _instance.title);
    }
    if (_instance.firstName) {
      _writer.writeString(3, _instance.firstName);
    }
    if (_instance.lastName) {
      _writer.writeString(4, _instance.lastName);
    }
  }

  private _type: string;
  private _title: string;
  private _firstName: string;
  private _lastName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GuestDetail to deeply clone from
   */
  constructor(_value?: RecursivePartial<GuestDetail.AsObject>) {
    _value = _value || {};
    this.type = _value.type;
    this.title = _value.title;
    this.firstName = _value.firstName;
    this.lastName = _value.lastName;
    GuestDetail.refineValues(this);
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get firstName(): string {
    return this._firstName;
  }
  set firstName(value: string) {
    this._firstName = value;
  }
  get lastName(): string {
    return this._lastName;
  }
  set lastName(value: string) {
    this._lastName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GuestDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GuestDetail.AsObject {
    return {
      type: this.type,
      title: this.title,
      firstName: this.firstName,
      lastName: this.lastName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GuestDetail.AsProtobufJSON {
    return {
      type: this.type,
      title: this.title,
      firstName: this.firstName,
      lastName: this.lastName
    };
  }
}
export module GuestDetail {
  /**
   * Standard JavaScript object representation for GuestDetail
   */
  export interface AsObject {
    type: string;
    title: string;
    firstName: string;
    lastName: string;
  }

  /**
   * Protobuf JSON representation for GuestDetail
   */
  export interface AsProtobufJSON {
    type: string;
    title: string;
    firstName: string;
    lastName: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.LeadGuest
 */
export class LeadGuest implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.LeadGuest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LeadGuest();
    LeadGuest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LeadGuest) {
    _instance.preferredContact = _instance.preferredContact || '';
    _instance.emailAddress = _instance.emailAddress || '';
    _instance.address = _instance.address || undefined;
    _instance.phone = _instance.phone || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LeadGuest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.preferredContact = _reader.readString();
          break;
        case 2:
          _instance.emailAddress = _reader.readString();
          break;
        case 3:
          _instance.address = new Address();
          _reader.readMessage(
            _instance.address,
            Address.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.phone = new Phone();
          _reader.readMessage(
            _instance.phone,
            Phone.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    LeadGuest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: LeadGuest, _writer: BinaryWriter) {
    if (_instance.preferredContact) {
      _writer.writeString(1, _instance.preferredContact);
    }
    if (_instance.emailAddress) {
      _writer.writeString(2, _instance.emailAddress);
    }
    if (_instance.address) {
      _writer.writeMessage(
        3,
        _instance.address as any,
        Address.serializeBinaryToWriter
      );
    }
    if (_instance.phone) {
      _writer.writeMessage(
        4,
        _instance.phone as any,
        Phone.serializeBinaryToWriter
      );
    }
  }

  private _preferredContact: string;
  private _emailAddress: string;
  private _address?: Address;
  private _phone?: Phone;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LeadGuest to deeply clone from
   */
  constructor(_value?: RecursivePartial<LeadGuest.AsObject>) {
    _value = _value || {};
    this.preferredContact = _value.preferredContact;
    this.emailAddress = _value.emailAddress;
    this.address = _value.address ? new Address(_value.address) : undefined;
    this.phone = _value.phone ? new Phone(_value.phone) : undefined;
    LeadGuest.refineValues(this);
  }
  get preferredContact(): string {
    return this._preferredContact;
  }
  set preferredContact(value: string) {
    this._preferredContact = value;
  }
  get emailAddress(): string {
    return this._emailAddress;
  }
  set emailAddress(value: string) {
    this._emailAddress = value;
  }
  get address(): Address | undefined {
    return this._address;
  }
  set address(value: Address | undefined) {
    this._address = value;
  }
  get phone(): Phone | undefined {
    return this._phone;
  }
  set phone(value: Phone | undefined) {
    this._phone = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LeadGuest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LeadGuest.AsObject {
    return {
      preferredContact: this.preferredContact,
      emailAddress: this.emailAddress,
      address: this.address ? this.address.toObject() : undefined,
      phone: this.phone ? this.phone.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LeadGuest.AsProtobufJSON {
    return {
      preferredContact: this.preferredContact,
      emailAddress: this.emailAddress,
      address: this.address ? this.address.toProtobufJSON(options) : null,
      phone: this.phone ? this.phone.toProtobufJSON(options) : null
    };
  }
}
export module LeadGuest {
  /**
   * Standard JavaScript object representation for LeadGuest
   */
  export interface AsObject {
    preferredContact: string;
    emailAddress: string;
    address?: Address.AsObject;
    phone?: Phone.AsObject;
  }

  /**
   * Protobuf JSON representation for LeadGuest
   */
  export interface AsProtobufJSON {
    preferredContact: string;
    emailAddress: string;
    address: Address.AsProtobufJSON | null;
    phone: Phone.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.Terms
 */
export class Terms implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.Terms';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Terms();
    Terms.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Terms) {
    _instance.text = _instance.text || [];
    _instance.links = _instance.links || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Terms, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Terms.Text();
          _reader.readMessage(
            messageInitializer1,
            Terms.Text.deserializeBinaryFromReader
          );
          (_instance.text = _instance.text || []).push(messageInitializer1);
          break;
        case 2:
          const messageInitializer2 = new Terms.Link();
          _reader.readMessage(
            messageInitializer2,
            Terms.Link.deserializeBinaryFromReader
          );
          (_instance.links = _instance.links || []).push(messageInitializer2);
          break;
        default:
          _reader.skipField();
      }
    }

    Terms.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Terms, _writer: BinaryWriter) {
    if (_instance.text && _instance.text.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.text as any,
        Terms.Text.serializeBinaryToWriter
      );
    }
    if (_instance.links && _instance.links.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.links as any,
        Terms.Link.serializeBinaryToWriter
      );
    }
  }

  private _text?: Terms.Text[];
  private _links?: Terms.Link[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Terms to deeply clone from
   */
  constructor(_value?: RecursivePartial<Terms.AsObject>) {
    _value = _value || {};
    this.text = (_value.text || []).map(m => new Terms.Text(m));
    this.links = (_value.links || []).map(m => new Terms.Link(m));
    Terms.refineValues(this);
  }
  get text(): Terms.Text[] | undefined {
    return this._text;
  }
  set text(value: Terms.Text[] | undefined) {
    this._text = value;
  }
  get links(): Terms.Link[] | undefined {
    return this._links;
  }
  set links(value: Terms.Link[] | undefined) {
    this._links = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Terms.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Terms.AsObject {
    return {
      text: (this.text || []).map(m => m.toObject()),
      links: (this.links || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Terms.AsProtobufJSON {
    return {
      text: (this.text || []).map(m => m.toProtobufJSON(options)),
      links: (this.links || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module Terms {
  /**
   * Standard JavaScript object representation for Terms
   */
  export interface AsObject {
    text?: Terms.Text.AsObject[];
    links?: Terms.Link.AsObject[];
  }

  /**
   * Protobuf JSON representation for Terms
   */
  export interface AsProtobufJSON {
    text: Terms.Text.AsProtobufJSON[] | null;
    links: Terms.Link.AsProtobufJSON[] | null;
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.Terms.Text
   */
  export class Text implements GrpcMessage {
    static id = 'ten.grpc.booking_service.dto.Terms.Text';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new Text();
      Text.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: Text) {
      _instance.title = _instance.title || '';
      _instance.body = _instance.body || '';
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(_instance: Text, _reader: BinaryReader) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.title = _reader.readString();
            break;
          case 2:
            _instance.body = _reader.readString();
            break;
          default:
            _reader.skipField();
        }
      }

      Text.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(_instance: Text, _writer: BinaryWriter) {
      if (_instance.title) {
        _writer.writeString(1, _instance.title);
      }
      if (_instance.body) {
        _writer.writeString(2, _instance.body);
      }
    }

    private _title: string;
    private _body: string;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of Text to deeply clone from
     */
    constructor(_value?: RecursivePartial<Text.AsObject>) {
      _value = _value || {};
      this.title = _value.title;
      this.body = _value.body;
      Text.refineValues(this);
    }
    get title(): string {
      return this._title;
    }
    set title(value: string) {
      this._title = value;
    }
    get body(): string {
      return this._body;
    }
    set body(value: string) {
      this._body = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      Text.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): Text.AsObject {
      return {
        title: this.title,
        body: this.body
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): Text.AsProtobufJSON {
      return {
        title: this.title,
        body: this.body
      };
    }
  }
  export module Text {
    /**
     * Standard JavaScript object representation for Text
     */
    export interface AsObject {
      title: string;
      body: string;
    }

    /**
     * Protobuf JSON representation for Text
     */
    export interface AsProtobufJSON {
      title: string;
      body: string;
    }
  }

  /**
   * Message implementation for ten.grpc.booking_service.dto.Terms.Link
   */
  export class Link implements GrpcMessage {
    static id = 'ten.grpc.booking_service.dto.Terms.Link';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new Link();
      Link.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: Link) {
      _instance.title = _instance.title || '';
      _instance.link = _instance.link || '';
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(_instance: Link, _reader: BinaryReader) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.title = _reader.readString();
            break;
          case 2:
            _instance.link = _reader.readString();
            break;
          default:
            _reader.skipField();
        }
      }

      Link.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(_instance: Link, _writer: BinaryWriter) {
      if (_instance.title) {
        _writer.writeString(1, _instance.title);
      }
      if (_instance.link) {
        _writer.writeString(2, _instance.link);
      }
    }

    private _title: string;
    private _link: string;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of Link to deeply clone from
     */
    constructor(_value?: RecursivePartial<Link.AsObject>) {
      _value = _value || {};
      this.title = _value.title;
      this.link = _value.link;
      Link.refineValues(this);
    }
    get title(): string {
      return this._title;
    }
    set title(value: string) {
      this._title = value;
    }
    get link(): string {
      return this._link;
    }
    set link(value: string) {
      this._link = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      Link.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): Link.AsObject {
      return {
        title: this.title,
        link: this.link
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): Link.AsProtobufJSON {
      return {
        title: this.title,
        link: this.link
      };
    }
  }
  export module Link {
    /**
     * Standard JavaScript object representation for Link
     */
    export interface AsObject {
      title: string;
      link: string;
    }

    /**
     * Protobuf JSON representation for Link
     */
    export interface AsProtobufJSON {
      title: string;
      link: string;
    }
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.Erratum
 */
export class Erratum implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.Erratum';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Erratum();
    Erratum.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Erratum) {
    _instance.subject = _instance.subject || '';
    _instance.description = _instance.description || '';
    _instance.erratumType = _instance.erratumType || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Erratum,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subject = _reader.readString();
          break;
        case 2:
          _instance.description = _reader.readString();
          break;
        case 3:
          _instance.erratumType = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Erratum.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Erratum, _writer: BinaryWriter) {
    if (_instance.subject) {
      _writer.writeString(1, _instance.subject);
    }
    if (_instance.description) {
      _writer.writeString(2, _instance.description);
    }
    if (_instance.erratumType) {
      _writer.writeString(3, _instance.erratumType);
    }
  }

  private _subject: string;
  private _description: string;
  private _erratumType: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Erratum to deeply clone from
   */
  constructor(_value?: RecursivePartial<Erratum.AsObject>) {
    _value = _value || {};
    this.subject = _value.subject;
    this.description = _value.description;
    this.erratumType = _value.erratumType;
    Erratum.refineValues(this);
  }
  get subject(): string {
    return this._subject;
  }
  set subject(value: string) {
    this._subject = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }
  get erratumType(): string {
    return this._erratumType;
  }
  set erratumType(value: string) {
    this._erratumType = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Erratum.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Erratum.AsObject {
    return {
      subject: this.subject,
      description: this.description,
      erratumType: this.erratumType
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Erratum.AsProtobufJSON {
    return {
      subject: this.subject,
      description: this.description,
      erratumType: this.erratumType
    };
  }
}
export module Erratum {
  /**
   * Standard JavaScript object representation for Erratum
   */
  export interface AsObject {
    subject: string;
    description: string;
    erratumType: string;
  }

  /**
   * Protobuf JSON representation for Erratum
   */
  export interface AsProtobufJSON {
    subject: string;
    description: string;
    erratumType: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.Cancellation
 */
export class Cancellation implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.Cancellation';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Cancellation();
    Cancellation.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Cancellation) {
    _instance.startDate = _instance.startDate || '';
    _instance.endDate = _instance.endDate || '';
    _instance.cancellationFee = _instance.cancellationFee || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Cancellation,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.startDate = _reader.readString();
          break;
        case 2:
          _instance.endDate = _reader.readString();
          break;
        case 3:
          _instance.cancellationFee = new AmountWithCurrency();
          _reader.readMessage(
            _instance.cancellationFee,
            AmountWithCurrency.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Cancellation.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: Cancellation,
    _writer: BinaryWriter
  ) {
    if (_instance.startDate) {
      _writer.writeString(1, _instance.startDate);
    }
    if (_instance.endDate) {
      _writer.writeString(2, _instance.endDate);
    }
    if (_instance.cancellationFee) {
      _writer.writeMessage(
        3,
        _instance.cancellationFee as any,
        AmountWithCurrency.serializeBinaryToWriter
      );
    }
  }

  private _startDate: string;
  private _endDate: string;
  private _cancellationFee?: AmountWithCurrency;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Cancellation to deeply clone from
   */
  constructor(_value?: RecursivePartial<Cancellation.AsObject>) {
    _value = _value || {};
    this.startDate = _value.startDate;
    this.endDate = _value.endDate;
    this.cancellationFee = _value.cancellationFee
      ? new AmountWithCurrency(_value.cancellationFee)
      : undefined;
    Cancellation.refineValues(this);
  }
  get startDate(): string {
    return this._startDate;
  }
  set startDate(value: string) {
    this._startDate = value;
  }
  get endDate(): string {
    return this._endDate;
  }
  set endDate(value: string) {
    this._endDate = value;
  }
  get cancellationFee(): AmountWithCurrency | undefined {
    return this._cancellationFee;
  }
  set cancellationFee(value: AmountWithCurrency | undefined) {
    this._cancellationFee = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Cancellation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Cancellation.AsObject {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Cancellation.AsProtobufJSON {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toProtobufJSON(options)
        : null
    };
  }
}
export module Cancellation {
  /**
   * Standard JavaScript object representation for Cancellation
   */
  export interface AsObject {
    startDate: string;
    endDate: string;
    cancellationFee?: AmountWithCurrency.AsObject;
  }

  /**
   * Protobuf JSON representation for Cancellation
   */
  export interface AsProtobufJSON {
    startDate: string;
    endDate: string;
    cancellationFee: AmountWithCurrency.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.PaymentDetail
 */
export class PaymentDetail implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.PaymentDetail';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PaymentDetail();
    PaymentDetail.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PaymentDetail) {
    _instance.cardType = _instance.cardType || '';
    _instance.cardHolderName = _instance.cardHolderName || '';
    _instance.ccNumber = _instance.ccNumber || '';
    _instance.expiryMonth = _instance.expiryMonth || 0;
    _instance.expiryYear = _instance.expiryYear || 0;
    _instance.cvc = _instance.cvc || '';
    _instance.offlineUse = _instance.offlineUse || false;
    _instance.onlineUse = _instance.onlineUse || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PaymentDetail,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 2:
          _instance.cardType = _reader.readString();
          break;
        case 3:
          _instance.cardHolderName = _reader.readString();
          break;
        case 4:
          _instance.ccNumber = _reader.readString();
          break;
        case 5:
          _instance.expiryMonth = _reader.readInt32();
          break;
        case 6:
          _instance.expiryYear = _reader.readInt32();
          break;
        case 7:
          _instance.cvc = _reader.readString();
          break;
        case 8:
          _instance.offlineUse = _reader.readBool();
          break;
        case 9:
          _instance.onlineUse = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PaymentDetail.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PaymentDetail,
    _writer: BinaryWriter
  ) {
    if (_instance.cardType) {
      _writer.writeString(2, _instance.cardType);
    }
    if (_instance.cardHolderName) {
      _writer.writeString(3, _instance.cardHolderName);
    }
    if (_instance.ccNumber) {
      _writer.writeString(4, _instance.ccNumber);
    }
    if (_instance.expiryMonth) {
      _writer.writeInt32(5, _instance.expiryMonth);
    }
    if (_instance.expiryYear) {
      _writer.writeInt32(6, _instance.expiryYear);
    }
    if (_instance.cvc) {
      _writer.writeString(7, _instance.cvc);
    }
    if (_instance.offlineUse) {
      _writer.writeBool(8, _instance.offlineUse);
    }
    if (_instance.onlineUse) {
      _writer.writeBool(9, _instance.onlineUse);
    }
  }

  private _cardType: string;
  private _cardHolderName: string;
  private _ccNumber: string;
  private _expiryMonth: number;
  private _expiryYear: number;
  private _cvc: string;
  private _offlineUse: boolean;
  private _onlineUse: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PaymentDetail to deeply clone from
   */
  constructor(_value?: RecursivePartial<PaymentDetail.AsObject>) {
    _value = _value || {};
    this.cardType = _value.cardType;
    this.cardHolderName = _value.cardHolderName;
    this.ccNumber = _value.ccNumber;
    this.expiryMonth = _value.expiryMonth;
    this.expiryYear = _value.expiryYear;
    this.cvc = _value.cvc;
    this.offlineUse = _value.offlineUse;
    this.onlineUse = _value.onlineUse;
    PaymentDetail.refineValues(this);
  }
  get cardType(): string {
    return this._cardType;
  }
  set cardType(value: string) {
    this._cardType = value;
  }
  get cardHolderName(): string {
    return this._cardHolderName;
  }
  set cardHolderName(value: string) {
    this._cardHolderName = value;
  }
  get ccNumber(): string {
    return this._ccNumber;
  }
  set ccNumber(value: string) {
    this._ccNumber = value;
  }
  get expiryMonth(): number {
    return this._expiryMonth;
  }
  set expiryMonth(value: number) {
    this._expiryMonth = value;
  }
  get expiryYear(): number {
    return this._expiryYear;
  }
  set expiryYear(value: number) {
    this._expiryYear = value;
  }
  get cvc(): string {
    return this._cvc;
  }
  set cvc(value: string) {
    this._cvc = value;
  }
  get offlineUse(): boolean {
    return this._offlineUse;
  }
  set offlineUse(value: boolean) {
    this._offlineUse = value;
  }
  get onlineUse(): boolean {
    return this._onlineUse;
  }
  set onlineUse(value: boolean) {
    this._onlineUse = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PaymentDetail.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PaymentDetail.AsObject {
    return {
      cardType: this.cardType,
      cardHolderName: this.cardHolderName,
      ccNumber: this.ccNumber,
      expiryMonth: this.expiryMonth,
      expiryYear: this.expiryYear,
      cvc: this.cvc,
      offlineUse: this.offlineUse,
      onlineUse: this.onlineUse
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PaymentDetail.AsProtobufJSON {
    return {
      cardType: this.cardType,
      cardHolderName: this.cardHolderName,
      ccNumber: this.ccNumber,
      expiryMonth: this.expiryMonth,
      expiryYear: this.expiryYear,
      cvc: this.cvc,
      offlineUse: this.offlineUse,
      onlineUse: this.onlineUse
    };
  }
}
export module PaymentDetail {
  /**
   * Standard JavaScript object representation for PaymentDetail
   */
  export interface AsObject {
    cardType: string;
    cardHolderName: string;
    ccNumber: string;
    expiryMonth: number;
    expiryYear: number;
    cvc: string;
    offlineUse: boolean;
    onlineUse: boolean;
  }

  /**
   * Protobuf JSON representation for PaymentDetail
   */
  export interface AsProtobufJSON {
    cardType: string;
    cardHolderName: string;
    ccNumber: string;
    expiryMonth: number;
    expiryYear: number;
    cvc: string;
    offlineUse: boolean;
    onlineUse: boolean;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.BrowserInfo
 */
export class BrowserInfo implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.BrowserInfo';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BrowserInfo();
    BrowserInfo.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BrowserInfo) {
    _instance.colorDepth = _instance.colorDepth || 0;
    _instance.javaEnabled = _instance.javaEnabled || false;
    _instance.language = _instance.language || '';
    _instance.screenHeight = _instance.screenHeight || 0;
    _instance.screenWidth = _instance.screenWidth || 0;
    _instance.timezoneOffset = _instance.timezoneOffset || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BrowserInfo,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.colorDepth = _reader.readInt32();
          break;
        case 2:
          _instance.javaEnabled = _reader.readBool();
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        case 4:
          _instance.screenHeight = _reader.readInt32();
          break;
        case 5:
          _instance.screenWidth = _reader.readInt32();
          break;
        case 6:
          _instance.timezoneOffset = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    BrowserInfo.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BrowserInfo,
    _writer: BinaryWriter
  ) {
    if (_instance.colorDepth) {
      _writer.writeInt32(1, _instance.colorDepth);
    }
    if (_instance.javaEnabled) {
      _writer.writeBool(2, _instance.javaEnabled);
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
    if (_instance.screenHeight) {
      _writer.writeInt32(4, _instance.screenHeight);
    }
    if (_instance.screenWidth) {
      _writer.writeInt32(5, _instance.screenWidth);
    }
    if (_instance.timezoneOffset) {
      _writer.writeInt32(6, _instance.timezoneOffset);
    }
  }

  private _colorDepth: number;
  private _javaEnabled: boolean;
  private _language: string;
  private _screenHeight: number;
  private _screenWidth: number;
  private _timezoneOffset: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BrowserInfo to deeply clone from
   */
  constructor(_value?: RecursivePartial<BrowserInfo.AsObject>) {
    _value = _value || {};
    this.colorDepth = _value.colorDepth;
    this.javaEnabled = _value.javaEnabled;
    this.language = _value.language;
    this.screenHeight = _value.screenHeight;
    this.screenWidth = _value.screenWidth;
    this.timezoneOffset = _value.timezoneOffset;
    BrowserInfo.refineValues(this);
  }
  get colorDepth(): number {
    return this._colorDepth;
  }
  set colorDepth(value: number) {
    this._colorDepth = value;
  }
  get javaEnabled(): boolean {
    return this._javaEnabled;
  }
  set javaEnabled(value: boolean) {
    this._javaEnabled = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get screenHeight(): number {
    return this._screenHeight;
  }
  set screenHeight(value: number) {
    this._screenHeight = value;
  }
  get screenWidth(): number {
    return this._screenWidth;
  }
  set screenWidth(value: number) {
    this._screenWidth = value;
  }
  get timezoneOffset(): number {
    return this._timezoneOffset;
  }
  set timezoneOffset(value: number) {
    this._timezoneOffset = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BrowserInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BrowserInfo.AsObject {
    return {
      colorDepth: this.colorDepth,
      javaEnabled: this.javaEnabled,
      language: this.language,
      screenHeight: this.screenHeight,
      screenWidth: this.screenWidth,
      timezoneOffset: this.timezoneOffset
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BrowserInfo.AsProtobufJSON {
    return {
      colorDepth: this.colorDepth,
      javaEnabled: this.javaEnabled,
      language: this.language,
      screenHeight: this.screenHeight,
      screenWidth: this.screenWidth,
      timezoneOffset: this.timezoneOffset
    };
  }
}
export module BrowserInfo {
  /**
   * Standard JavaScript object representation for BrowserInfo
   */
  export interface AsObject {
    colorDepth: number;
    javaEnabled: boolean;
    language: string;
    screenHeight: number;
    screenWidth: number;
    timezoneOffset: number;
  }

  /**
   * Protobuf JSON representation for BrowserInfo
   */
  export interface AsProtobufJSON {
    colorDepth: number;
    javaEnabled: boolean;
    language: string;
    screenHeight: number;
    screenWidth: number;
    timezoneOffset: number;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.RequestMeta
 */
export class RequestMeta implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.RequestMeta';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RequestMeta();
    RequestMeta.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RequestMeta) {
    _instance.basketId = _instance.basketId || 0;
    _instance.shopperIp = _instance.shopperIp || '';
    _instance.accept = _instance.accept || '';
    _instance.userAgent = _instance.userAgent || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RequestMeta,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.basketId = _reader.readInt32();
          break;
        case 2:
          _instance.shopperIp = _reader.readString();
          break;
        case 3:
          _instance.accept = _reader.readString();
          break;
        case 4:
          _instance.userAgent = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    RequestMeta.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RequestMeta,
    _writer: BinaryWriter
  ) {
    if (_instance.basketId) {
      _writer.writeInt32(1, _instance.basketId);
    }
    if (_instance.shopperIp) {
      _writer.writeString(2, _instance.shopperIp);
    }
    if (_instance.accept) {
      _writer.writeString(3, _instance.accept);
    }
    if (_instance.userAgent) {
      _writer.writeString(4, _instance.userAgent);
    }
  }

  private _basketId: number;
  private _shopperIp: string;
  private _accept: string;
  private _userAgent: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RequestMeta to deeply clone from
   */
  constructor(_value?: RecursivePartial<RequestMeta.AsObject>) {
    _value = _value || {};
    this.basketId = _value.basketId;
    this.shopperIp = _value.shopperIp;
    this.accept = _value.accept;
    this.userAgent = _value.userAgent;
    RequestMeta.refineValues(this);
  }
  get basketId(): number {
    return this._basketId;
  }
  set basketId(value: number) {
    this._basketId = value;
  }
  get shopperIp(): string {
    return this._shopperIp;
  }
  set shopperIp(value: string) {
    this._shopperIp = value;
  }
  get accept(): string {
    return this._accept;
  }
  set accept(value: string) {
    this._accept = value;
  }
  get userAgent(): string {
    return this._userAgent;
  }
  set userAgent(value: string) {
    this._userAgent = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RequestMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RequestMeta.AsObject {
    return {
      basketId: this.basketId,
      shopperIp: this.shopperIp,
      accept: this.accept,
      userAgent: this.userAgent
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RequestMeta.AsProtobufJSON {
    return {
      basketId: this.basketId,
      shopperIp: this.shopperIp,
      accept: this.accept,
      userAgent: this.userAgent
    };
  }
}
export module RequestMeta {
  /**
   * Standard JavaScript object representation for RequestMeta
   */
  export interface AsObject {
    basketId: number;
    shopperIp: string;
    accept: string;
    userAgent: string;
  }

  /**
   * Protobuf JSON representation for RequestMeta
   */
  export interface AsProtobufJSON {
    basketId: number;
    shopperIp: string;
    accept: string;
    userAgent: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.ThreeDSOne
 */
export class ThreeDSOne implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.ThreeDSOne';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ThreeDSOne();
    ThreeDSOne.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ThreeDSOne) {
    _instance.md = _instance.md || '';
    _instance.paRequest = _instance.paRequest || '';
    _instance.issuerUrl = _instance.issuerUrl || '';
    _instance.termUrl = _instance.termUrl || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ThreeDSOne,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.md = _reader.readString();
          break;
        case 2:
          _instance.paRequest = _reader.readString();
          break;
        case 3:
          _instance.issuerUrl = _reader.readString();
          break;
        case 4:
          _instance.termUrl = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ThreeDSOne.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ThreeDSOne, _writer: BinaryWriter) {
    if (_instance.md) {
      _writer.writeString(1, _instance.md);
    }
    if (_instance.paRequest) {
      _writer.writeString(2, _instance.paRequest);
    }
    if (_instance.issuerUrl) {
      _writer.writeString(3, _instance.issuerUrl);
    }
    if (_instance.termUrl) {
      _writer.writeString(4, _instance.termUrl);
    }
  }

  private _md: string;
  private _paRequest: string;
  private _issuerUrl: string;
  private _termUrl: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ThreeDSOne to deeply clone from
   */
  constructor(_value?: RecursivePartial<ThreeDSOne.AsObject>) {
    _value = _value || {};
    this.md = _value.md;
    this.paRequest = _value.paRequest;
    this.issuerUrl = _value.issuerUrl;
    this.termUrl = _value.termUrl;
    ThreeDSOne.refineValues(this);
  }
  get md(): string {
    return this._md;
  }
  set md(value: string) {
    this._md = value;
  }
  get paRequest(): string {
    return this._paRequest;
  }
  set paRequest(value: string) {
    this._paRequest = value;
  }
  get issuerUrl(): string {
    return this._issuerUrl;
  }
  set issuerUrl(value: string) {
    this._issuerUrl = value;
  }
  get termUrl(): string {
    return this._termUrl;
  }
  set termUrl(value: string) {
    this._termUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ThreeDSOne.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ThreeDSOne.AsObject {
    return {
      md: this.md,
      paRequest: this.paRequest,
      issuerUrl: this.issuerUrl,
      termUrl: this.termUrl
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ThreeDSOne.AsProtobufJSON {
    return {
      md: this.md,
      paRequest: this.paRequest,
      issuerUrl: this.issuerUrl,
      termUrl: this.termUrl
    };
  }
}
export module ThreeDSOne {
  /**
   * Standard JavaScript object representation for ThreeDSOne
   */
  export interface AsObject {
    md: string;
    paRequest: string;
    issuerUrl: string;
    termUrl: string;
  }

  /**
   * Protobuf JSON representation for ThreeDSOne
   */
  export interface AsProtobufJSON {
    md: string;
    paRequest: string;
    issuerUrl: string;
    termUrl: string;
  }
}

/**
 * Message implementation for ten.grpc.booking_service.dto.ThreeDSTwoV2
 */
export class ThreeDSTwoV2 implements GrpcMessage {
  static id = 'ten.grpc.booking_service.dto.ThreeDSTwoV2';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ThreeDSTwoV2();
    ThreeDSTwoV2.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ThreeDSTwoV2) {
    _instance.threeDsTransId = _instance.threeDsTransId || '';
    _instance.acsUrl = _instance.acsUrl || '';
    _instance.acsTransId = _instance.acsTransId || '';
    _instance.messageVersion = _instance.messageVersion || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ThreeDSTwoV2,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.threeDsTransId = _reader.readString();
          break;
        case 2:
          _instance.acsUrl = _reader.readString();
          break;
        case 3:
          _instance.acsTransId = _reader.readString();
          break;
        case 4:
          _instance.messageVersion = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ThreeDSTwoV2.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ThreeDSTwoV2,
    _writer: BinaryWriter
  ) {
    if (_instance.threeDsTransId) {
      _writer.writeString(1, _instance.threeDsTransId);
    }
    if (_instance.acsUrl) {
      _writer.writeString(2, _instance.acsUrl);
    }
    if (_instance.acsTransId) {
      _writer.writeString(3, _instance.acsTransId);
    }
    if (_instance.messageVersion) {
      _writer.writeString(4, _instance.messageVersion);
    }
  }

  private _threeDsTransId: string;
  private _acsUrl: string;
  private _acsTransId: string;
  private _messageVersion: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ThreeDSTwoV2 to deeply clone from
   */
  constructor(_value?: RecursivePartial<ThreeDSTwoV2.AsObject>) {
    _value = _value || {};
    this.threeDsTransId = _value.threeDsTransId;
    this.acsUrl = _value.acsUrl;
    this.acsTransId = _value.acsTransId;
    this.messageVersion = _value.messageVersion;
    ThreeDSTwoV2.refineValues(this);
  }
  get threeDsTransId(): string {
    return this._threeDsTransId;
  }
  set threeDsTransId(value: string) {
    this._threeDsTransId = value;
  }
  get acsUrl(): string {
    return this._acsUrl;
  }
  set acsUrl(value: string) {
    this._acsUrl = value;
  }
  get acsTransId(): string {
    return this._acsTransId;
  }
  set acsTransId(value: string) {
    this._acsTransId = value;
  }
  get messageVersion(): string {
    return this._messageVersion;
  }
  set messageVersion(value: string) {
    this._messageVersion = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ThreeDSTwoV2.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ThreeDSTwoV2.AsObject {
    return {
      threeDsTransId: this.threeDsTransId,
      acsUrl: this.acsUrl,
      acsTransId: this.acsTransId,
      messageVersion: this.messageVersion
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ThreeDSTwoV2.AsProtobufJSON {
    return {
      threeDsTransId: this.threeDsTransId,
      acsUrl: this.acsUrl,
      acsTransId: this.acsTransId,
      messageVersion: this.messageVersion
    };
  }
}
export module ThreeDSTwoV2 {
  /**
   * Standard JavaScript object representation for ThreeDSTwoV2
   */
  export interface AsObject {
    threeDsTransId: string;
    acsUrl: string;
    acsTransId: string;
    messageVersion: string;
  }

  /**
   * Protobuf JSON representation for ThreeDSTwoV2
   */
  export interface AsProtobufJSON {
    threeDsTransId: string;
    acsUrl: string;
    acsTransId: string;
    messageVersion: string;
  }
}
